// Global error handler to mitigate Android Java object errors

export const setupGlobalErrorHandler = () => {
  const isWebViewSystemError = (errStr: string) => {
    return errStr.includes("Java object is gone") ||
           errStr.includes("webkit.messageHandlers") ||
           errStr.includes("Java bridge") ||
           errStr.includes("null is not an object (evaluating 'window.webkit.messageHandlers") ||
           errStr.includes("enableDidUserTypeOnKeyboardLogging") ||
           errStr.includes("clarity");
  };

  // Handle JavaScript errors
  window.addEventListener('error', function(event) {
    try {
      const errorMsg = event.message || "";
      const errorObjStr = event.error ? String(event.error) : "";
      const errorStack = event.error?.stack ? String(event.error.stack) : "";

      if (isWebViewSystemError(errorMsg) || isWebViewSystemError(errorObjStr) || isWebViewSystemError(errorStack)) {
        event.preventDefault(); // Evita que el error suba a la consola y afecte métricas
        console.warn("Error de sistema de WebView/Clarity ignorado de forma segura:", errorMsg || errorObjStr);
        return true;
      }
    } catch (e) {
      // Ignorar errores en el propio manejador
    }
    return false;
  }, true);

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', function(event) {
    try {
      const reasonMsg = event.reason?.message || "";
      const reasonStr = event.reason ? String(event.reason) : "";
      const reasonStack = event.reason?.stack ? String(event.reason.stack) : "";

      if (isWebViewSystemError(reasonMsg) || isWebViewSystemError(reasonStr) || isWebViewSystemError(reasonStack)) {
        event.preventDefault();
        console.warn("Promise rejection de WebView/Clarity ignorada de forma segura:", reasonMsg || reasonStr);
        return true;
      }
    } catch (e) {
      // Ignorar
    }
    return false;
  });
};

// Initialize error handler when module loads
if (typeof window !== 'undefined') {
  setupGlobalErrorHandler();
}
